import './Modal.css'

function Modal({ isOpen, title, children, footer, onClose }) {
    if (!isOpen) {
        return null
    }

    return (
        <div
            className="modalOverlay"
            onClick={onClose}
        >
            <div
                className="modalBox"
                onClick={(event) => event.stopPropagation()}
            >
                <div className="modalHeader">
                    <h2>{title}</h2>

                    <button
                        type="button"
                        className="modalClose"
                        onClick={onClose}
                    >
                        ×
                    </button>
                </div>

                <div className="modalBody">
                    {children}
                </div>

                {footer && (
                    <div className="modalFooter">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    )
}

export default Modal